import moment from 'moment';

const yearSelectOffset = 10;

export const getCalendarSelectItems = {
  year: (validRange) => {
    const start =
      validRange?.[0]?.get('year') || moment().get('year') - yearSelectOffset;
    const end =
      validRange?.[1]?.get('year') + 1 ||
      moment().get('year') + yearSelectOffset;

    const items = [];

    for (let i = start; i < end; i += 1) {
      items.push({ id: i, name: i });
    }

    return items;
  },

  month: (validRange, date) => {
    let start = 0;
    let end = 12;

    if (validRange) {
      const [rangeStart, rangeEnd] = validRange;
      const currentYear = date.get('year');

      if (rangeEnd.get('year') === currentYear) {
        end = rangeEnd.get('month') + 1;
      }

      if (rangeStart.get('year') === currentYear) {
        start = rangeStart.get('month');
      }
    }

    const cloneDate = date.clone();
    const localeData = date.localeData();

    const items = [];

    for (let i = start; i < end; i++) {
      cloneDate.month(i);
      items.push({ id: i, name: localeData.monthsShort(cloneDate) });
    }

    return items;
  },
};
